var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"separator base-separator"},[_c('span',{staticClass:"text-body-1"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }